
// проверяет icon для транзакций
export function iconLink(trx) {
  if (trx?.auToken?.logoMain) {
    return trx.auToken.logoMain;
  }
  if (trx?.auToken?.mainImage?.name) {
    return trx.auToken.mainImage.name;
  }
  if (trx?.auCapital?.mainImage?.name) {
    return trx.auCapital.mainImage.name;
  }
  return "/svg/companies/s_logo.svg";
}
